import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/auth/auth-context';
import { ApiError } from '@/lib/api';
import { CustomMarcaCasaANome } from '@/components/CustomMarcasCasaA';

const Signin: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [verSenha, setVerSenha] = useState(false);
  const [entrando, setEntrando] = useState(false);
  const [mostrarAjudaSenha, setMostrarAjudaSenha] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setEntrando(true);
    try {
      await login(usuario.trim(), senha);
      navigate('/inicio', { replace: true });
    } catch (err) {
      toast.error(
        err instanceof ApiError ? err.message : 'Usuário ou senha inválidos.',
      );
    } finally {
      setEntrando(false);
    }
  };

  return (
    <div
      className="row justify-content-center minheight-dynamic z-index-1 position-relative"
      style={{ '--mih-dynamic': 'calc(100vh - 135px)' } as React.CSSProperties}
    >
      <div className="col-12 col-md-8 col-xl-6">
        <div className="h-100 py-4 px-md-3">
          <div className="row h-100 align-items-center justify-content-center mt-md-3">
            <div className="col-12 col-sm-8 col-md-11 col-xl-11 col-xxl-10 login-box">
              <form className="auth-form" onSubmit={handleSubmit}>
                <div className="card adminuiux-card mb-2">
                  <div className="card-body">
                    {/* A MARCA, não a palavra digitada. Até 05/09/2026 isto era
                        um `<h2>Casa A</h2>`: a tela escrevia o nome de duas
                        formas — vetor no topo, texto no cartão — e quem
                        mudasse a marca mudaria só uma delas.

                        `text-theme-1` porque o SVG é `fill: currentColor`: a
                        marca herda a cor de quem a contém, e sobre o cartão
                        branco quem manda é a cor do tema. Tamanho na folha
                        (`.casaa-login-marca`), nunca em prop. */}
                    <div className="text-center mb-4">
                      <CustomMarcaCasaANome className="casaa-login-marca text-theme-1 mb-2" />
                      <p className="text-secondary mb-0">Operação · Ordens de Serviço</p>
                    </div>
                    <div className="form-floating mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="usuario"
                        placeholder="Usuário ou e-mail"
                        value={usuario}
                        onChange={(e) => setUsuario(e.target.value)}
                        autoFocus
                      />
                      <label htmlFor="usuario">Usuário ou e-mail</label>
                    </div>
                    <div className="position-relative">
                      <div className="form-floating mb-3">
                        <input
                          type={verSenha ? 'text' : 'password'}
                          className="form-control"
                          id="senha"
                          placeholder="Senha"
                          value={senha}
                          onChange={(e) => setSenha(e.target.value)}
                        />
                        <label htmlFor="senha">Senha</label>
                      </div>
                      <button
                        className="btn btn-square btn-link text-theme-1 position-absolute end-0 top-0 mt-2 me-2"
                        type="button"
                        onClick={() => setVerSenha((v) => !v)}
                      >
                        <i className={`bi ${verSenha ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                      </button>
                    </div>
                    <div className="row gx-3 align-items-center">
                      <div className="col">
                        <button
                          type="submit"
                          className="btn btn-lg btn-theme w-100"
                          disabled={entrando}
                        >
                          {entrando && (
                            <span className="spinner-border spinner-border-sm me-2" />
                          )}
                          Entrar
                        </button>
                      </div>
                    </div>

                    {/* ESQUECI MINHA SENHA — o mínimo honesto, enquanto não há e-mail.
                        ------------------------------------------------------------
                        Ele pediu isto em 05/09/2026: *"esse formulário de login não
                        tem recuperar senha, deveria ter"*.

                        **O fluxo por e-mail não cabe aqui**, e o motivo é medido: o
                        app não envia e-mail nenhum hoje. Um "recuperar senha" de
                        verdade é token com validade, tabela, e o envio configurado —
                        frente própria, registrada no backlog.

                        O que NÃO se faz é o pior dos dois mundos: um link que abre
                        um formulário de e-mail que não manda nada. Isso é pior que
                        não ter link — a pessoa digita, espera, e nada chega.

                        Então aqui vai o caminho que funciona hoje: dizer a quem
                        pedir. A redefinição já existe na tela de Usuários. */}
                    <div className="text-center mt-3">
                      <button
                        type="button"
                        className="btn btn-sm btn-link text-secondary text-decoration-none"
                        onClick={() => setMostrarAjudaSenha((v) => !v)}
                        aria-expanded={mostrarAjudaSenha}
                      >
                        Esqueci minha senha
                      </button>
                    </div>
                    {mostrarAjudaSenha && (
                      <div className="alert alert-theme-1 mt-2 mb-0 py-2 px-3 small">
                        Peça a quem administra o sistema para gerar uma senha nova
                        para você — leva um minuto, em <strong>Usuários</strong>.
                        Você troca por uma sua assim que entrar, em{' '}
                        <strong>Acesso e Senha</strong>.
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
